import { Task, Timestamp, WeekDays } from '@griply/types';

import { getTaskPlanning } from './get-task-planning';
import { getTimeframeSchedules } from './schedules';

export type HasUpcomingHabitOccurrenceOptions = {
  startDate: Timestamp;
  endDate: Timestamp;
  today: Timestamp;
  weekStartsOn: WeekDays;
};

export const hasUpcomingHabitOccurrence = (
  habits: Task[],
  {
    startDate,
    endDate,
    today,
    weekStartsOn,
  }: HasUpcomingHabitOccurrenceOptions,
): boolean =>
  habits.some((habit) => {
    // a times-per-week habit has no concrete future occurrence, so an active one counts on its own
    const windowSchedules = getTimeframeSchedules(habit.schedules ?? [], {
      startDate,
      endDate,
    });

    if (windowSchedules.some(({ frequency }) => frequency?.count)) {
      return true;
    }

    return !!getTaskPlanning(habit, {
      startDate,
      endDate,
      today,
      weekStartsOn,
      uncompletedOnly: true,
    }).length;
  });
